import $ from 'jquery';

$(document).on('ready turbolinks:load', function () {
  let current_pathname = location.pathname;
  const regex = /^\/clients\/(\d+)\/edit$/;
  if (current_pathname.match(regex)) {
    let bill_target_type_input = 'input[type="radio"][name="client[bill_target_type]"]';

    $(bill_target_type_input).change(function () {
      $('#warning-switch-bill-target-type').modal('show');
    });
  }

  $('.client-edit-work-pages .js-product-select,.client-edit-work-pages .js-sales-user-select').select2({
    width: '100%',
  });

  $('.client-edit-work-pages .js-format-float-field').each(function () {
    var value = $(this).val();
    if (value) {
      value = value.replace(/,/g, '');
      $(this).val(value.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    }
  });

  select2ClientProductAjax();

  $('#client_page_products')
    .on('cocoon:after-insert', function (e, added_item) {
      select2ClientProductAjax();
      added_item.after($('#js-link-to-add-item'));

      let sortable_wrapper = $(added_item).parents('.client-products-sortable');
      let items = sortable_wrapper.find('.client-product-item:not([style*="display: none"])');

      let added_item_index = items.length;
      $(added_item).find('input.js-sort-index-val').val(added_item_index);
    }).on('cocoon:after-remove', function () {
      updateSortIndex();
    });

  $(".client-products-sortable").sortable({
    items: ".client-product-item:not(.unsortable)",
    update: function () {
      updateSortIndex();
    }
  });
});

function updateSortIndex() {
  let items = $(".client-products-sortable .client-product-item:not([style*='display: none'])");

  items.each(function (index) {
    $(this).find('input.js-sort-index-val').val(index + 1);
  });
}

$(document).on('change', '.nested-fields .js-source-sale-users', function () {
  const selectedValue = $(this).val();

  if (!$('#sync_sale_user_on_right_table_checkbox').is(':checked')) {
    return;
  }

  $('.nested-fields .js-source-sale-users').each(function () {
    if ($(this).val() !== selectedValue) {
      $(this).val(selectedValue).trigger('change');
    }
  });
});


function select2ClientProductAjax() {
  $('.js-source-client-products-ajax').select2({
    ajax: {
      url: '/products.json',
      dataType: 'json',
      data: function (params) {
        let except_product_ids = [];
        let items = $('.js-source-client-products-ajax');
        for (let i = 0; i < items.length; i++) {
          let p_id = $(items[i]).val();
          if (p_id != null && p_id != "") {
            except_product_ids.push(p_id);
          }
        }

        return {
          q: { name_or_code_or_general_name_or_client_products_special_product_name_cont: params.term },
          except_product_ids: except_product_ids,
          page: params.page || 1
        }
      },
      processResults: function (data, params) {
        params.page = params.page || 1;

        return {
          results: $.map(data, function (item) {
            let item_name = item.name;
            let item_price = item.price;
            let item_unit_type = item.unit_type_localization;

            let item_text_display = item_name + '、' + item.code;

            return { text: item_text_display, id: item.id, price: item_price, unit_type: item_unit_type }
          })
        };
      },
      cache: true,
      minimumInputLength: 1
    },
    placeholder: "商品名",
    language: {
      noResults: function () {
        return "見つかりません";
      }
    }
  });
}
